// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productVideos":"ZF2MC","videoParentContainer":"b2z4X","videoChildContainer":"ZdMzM","videoJs":"_4p321","closeButton":"_0jsri","hide":"_9BIhf","defaultVideos":"iqjzR"};